module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ni-e78c1b2a6eb17bbe0c175b35a4eb66ca.svg";